import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import React from 'react'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const DidYouKnowBanner = () => {
  const {language, domain, locale, deviceType} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  return (
    <div className={clsx(deviceType !== 'desktop' && `${stylesBydomain.UTILS_MAIN_CONTAINER} utils_main_container`)}>
      <div
        className={clsx(
          'flex flex-col items-center justify-center gap-2 px-5 py-6 tablet:items-start tablet:justify-start tablet:rounded-2xl',
          stylesBydomain.HOMEPAGE_DID_YOU_KNOW_BG,
          'homepage_did_you_know_bg',
        )}
      >
        <div
          className={clsx(
            'rounded-full px-4 py-1 text-base tracking-wider text-white',
            stylesBydomain.HOMEPAGE_DID_YOU_KNOW_CTA,
            'homepage_did_you_know_cta',
          )}
        >
          {translations.Home.DidYouKnowBanner.title}
        </div>
        <div className={clsx('font-light', stylesBydomain.HOMEPAGE_DID_YOU_KNOW_TEXT, 'homepage_did_you_know_text')}>
          {translations.Home.DidYouKnowBanner.description}
        </div>
      </div>
    </div>
  )
}

export default DidYouKnowBanner
